import { render, staticRenderFns } from "./configurations.vue?vue&type=template&id=b716138e"
import script from "./configurations.vue?vue&type=script&lang=js"
export * from "./configurations.vue?vue&type=script&lang=js"
import style0 from "./configurations.vue?vue&type=style&index=0&id=b716138e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports